import { render, staticRenderFns } from "./UserManagementGrid.vue?vue&type=template&id=5457f8ee"
import script from "./UserManagementGrid.vue?vue&type=script&lang=js"
export * from "./UserManagementGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports